var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "alpheios-user-auth" }, [
    _c(
      "div",
      { staticClass: "alpheios-user-auth__user-container" },
      [
        _c("login", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.app.platform.isSafariAppExtension,
              expression: "!app.platform.isSafariAppExtension",
            },
          ],
        }),
        _vm._v(" "),
        _vm.app.platform.isSafariAppExtension
          ? _c("div", [
              _c("iframe", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: this.$store.state.auth.isAuthenticated,
                    expression: "this.$store.state.auth.isAuthenticated",
                  },
                ],
                staticStyle: {
                  width: "100%",
                  height: "60px",
                  border: "none",
                  overflow: "visible",
                },
                attrs: { src: this.auth.iFrameSafariURL + "#auth=1" },
              }),
              _vm._v(" "),
              _c("iframe", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !this.$store.state.auth.isAuthenticated,
                    expression: "!this.$store.state.auth.isAuthenticated",
                  },
                ],
                staticStyle: {
                  width: "100%",
                  height: "60px",
                  border: "none",
                  overflow: "visible",
                },
                attrs: { src: this.auth.iFrameSafariURL + "#auth=0" },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: this.$store.state.auth.isAuthenticated,
                expression: "this.$store.state.auth.isAuthenticated",
              },
            ],
            staticClass: "alpheios-user-auth__user-info-box",
          },
          [
            _c(
              "div",
              { staticClass: "alpheios-user-auth__user-info-item-box" },
              [
                _c(
                  "div",
                  { staticClass: "alpheios-user-auth__user-info-item-name" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.l10n.getMsg("AUTH_PROFILE_NICKNAME_LABEL")) +
                        ":\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "alpheios-user-auth__user-info-item-value" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          this.$store.state.auth.userNickName
                            ? this.$store.state.auth.userNickName
                            : "—"
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alpheios-user-auth__credits" }, [
      _c(
        "a",
        {
          attrs: {
            width: "150",
            height: "50",
            href: "https://auth0.com/?utm_source=oss&utm_medium=gp&utm_campaign=oss",
            target: "_blank",
            alt: "Single Sign On & Token Based Authentication - Auth0",
          },
        },
        [
          _c("img", {
            attrs: {
              width: "150",
              height: "50",
              alt: "JWT Auth for open source projects",
              src: "https://cdn.auth0.com/oss/badges/a0-badge-dark.png",
            },
          }),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }